import BrandLogo from "./components/BrandLogo";
import { Outlet, Link, useLocation } from "react-router-dom";
import { useState } from "react";
import { Authenticated, Unauthenticated, AuthLoading } from "convex/react";
import { useAuthActions } from "@convex-dev/auth/react";
import Signup from "./components/signup/Signup";
import PlayerHolder from "./components/player/PlayerHolder";
import { ThemeProvider, createTheme } from "@mui/material/styles";
export type PlayerContext = {
  player_episode_id: string;
  set_player_episode_id: React.Dispatch<React.SetStateAction<string>>;
};
const theme = createTheme({
  palette: {
    mode: "dark",
    primary: { main: "#60a5fa" },
    background: { default: "#090d12", paper: "#10161e" },
  },
});
function deviceId() {
  let id = localStorage.getItem("deviceId");
  if (!id) {
    id = crypto.randomUUID();
    localStorage.setItem("deviceId", id);
  }
  return id;
}
export default function App() {
  const location = useLocation();
  const [player_episode_id, set_player_episode_id] = useState("");
  const [device] = useState(deviceId);
  const { signOut } = useAuthActions();
  return (
    <ThemeProvider theme={theme}>
      <div className="app">
        <header className="topbar">
          <Link className="brand" to="/">
            <BrandLogo />
          </Link>
          <div className="top-sub">History, mapped across time and place</div>
          <div className="top-spacer" />
          <nav className="site-nav">
            <Link to="/timeline">Explore</Link>
            <Link to="/play_history">Listening history</Link>
            <Link to="/about">About</Link>
            <Unauthenticated><Link to="/signup">Join</Link></Unauthenticated>
            <Authenticated>
              <button className="top-btn" onClick={() => void signOut()}>
                Sign out
              </button>
            </Authenticated>
          </nav>
        </header>
        <AuthLoading>
          <div className="empty">Connecting to the archive…</div>
        </AuthLoading>
        <Authenticated>
          <Outlet context={{ player_episode_id, set_player_episode_id }} />
        </Authenticated>
        <Unauthenticated>
          {location.pathname === "/about" ? <Outlet /> : <Signup />}
        </Unauthenticated>
        {player_episode_id && (
          <section className="player-dock" aria-label="Audio player">
            <PlayerHolder
              playerEpisodeId={player_episode_id}
              setPlayerEpisodeId={set_player_episode_id}
              deviceId={device}
            />
          </section>
        )}
      </div>
    </ThemeProvider>
  );
}
